import { AxiosResponse } from 'axios'
import { httpClient } from 'shared/api/http-client'
import { LOGIN_API } from 'modules/authentication/api/constants'
import {
  RegisterConfirmApiInterface,
  RegisterConfirmResponseInterface,
} from 'modules/authentication/types/post-register-interface'
import {
  CommunityInterface,
  CreateCommunityInterface,
} from 'modules/community/types/community-interface'
import { PostInterface } from 'modules/community/types/post-interface'

export function updateCommunitySettings(
  communityPath: string,
  data: CreateCommunityInterface,
): Promise<AxiosResponse<CommunityInterface, unknown, {}>> {
  return httpClient.patch<CommunityInterface>(
    `/api/community/community/${communityPath}/settings`,
    data,
  )
}

export function registerCommunity(
  email: string,
  communityUrl: string,
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(`/api/register`, {
    email,
    communityUrl,
  })
}

export function createPassword(
  params: RegisterConfirmApiInterface,
): Promise<AxiosResponse<RegisterConfirmResponseInterface, unknown, {}>> {
  const { token, firstName, lastName, captcha, plainPassword } = params
  return httpClient.post<RegisterConfirmResponseInterface>('/api/security/register/confirm', {
    token: token,
    firstName: firstName,
    lastName: lastName,
    captcha: captcha,
    plainPassword: plainPassword,
  })
}

export function login(
  email: string,
  password: string,
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(LOGIN_API, {
    email,
    password,
  })
}

export function likePost(
  postId: PostInterface['id'],
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(`/api/community/post/${postId}/like`)
}

export function unlikePost(
  postId: PostInterface['id'],
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.delete(`/api/community/post/${postId}/remove-like`)
}
